import { SortConfig } from 'store/types/Table';
import { OrderPayment } from 'store/types/Payment';
import { sorter } from 'util/Table';
import { ALL_COMPANIES_DROPDOWN_KEY } from 'util/Company';

export enum InvoicesTableActionType {
  SetInitialList = 'SetInitialList',
  UpdateSort = 'UpdateSort',
  UpdateFilter = 'UpdateFilter',
  OpenDetails = 'OpenDetails',
  CloseDetails = 'CloseDetails',
}

export interface InvoicesTableState {
  initialList: OrderPayment[];
  list: OrderPayment[];
  sort: SortConfig<OrderPayment>;
  clickedItem?: OrderPayment;
  companyId?: string;
  isCompany: boolean;
  hasMultiSubsidiaries: boolean;
}

export interface InvoicesTableAction {
  type: InvoicesTableActionType;
  payload: Partial<InvoicesTableState & { selectedItem?: OrderPayment; subsidiaryId?: string }>;
}

const getSortedList = (list: OrderPayment[] = [], sort: SortConfig<OrderPayment>): OrderPayment[] =>
  list.length ? [...list].sort(sorter<OrderPayment>(sort)) : [...list];

export const initialState: InvoicesTableState = {
  initialList: [],
  list: [],
  sort: { direction: 'desc', column: 'status' },
  clickedItem: undefined,
  companyId: '',
  isCompany: false,
  hasMultiSubsidiaries: false,
};

const reducer = (state: InvoicesTableState, { type, payload }: InvoicesTableAction): InvoicesTableState => {
  if (type === InvoicesTableActionType.SetInitialList) {
    const { initialList = [], list = [], companyId = '', isCompany = false } = payload;
    const filteredList =
      isCompany && companyId !== ALL_COMPANIES_DROPDOWN_KEY ? list.filter((item) => item.ownerId === companyId) : list;
    const sortedList = getSortedList(filteredList, state.sort);

    return { ...state, initialList, list: sortedList };
  }

  if (type === InvoicesTableActionType.UpdateSort) {
    const { sort = {} } = payload;

    return {
      ...state,
      sort,
      list: getSortedList(state.initialList, sort),
    };
  }

  if (type === InvoicesTableActionType.UpdateFilter) {
    const { subsidiaryId = '', companyId = '', hasMultiSubsidiaries } = payload;

    const filteredByCompany =
      companyId !== ALL_COMPANIES_DROPDOWN_KEY
        ? state.initialList.filter((item) => item.ownerId === companyId)
        : state.initialList;

    const filteredList =
      hasMultiSubsidiaries && subsidiaryId
        ? filteredByCompany.filter((item) => item.subsidiaryId === subsidiaryId)
        : hasMultiSubsidiaries && !subsidiaryId
        ? []
        : filteredByCompany;

    return {
      ...state,
      list: filteredList,
    };
  }

  if (type === InvoicesTableActionType.OpenDetails) {
    const { clickedItem } = payload;

    return { ...state, clickedItem };
  }

  if (type === InvoicesTableActionType.CloseDetails) {
    return { ...state, clickedItem: undefined };
  }

  return state;
};

export default reducer;
